import Avatar from "@material-ui/core/Avatar";
import clsx from "clsx";
import Collapse from "@material-ui/core/Collapse";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import HomeIcon from "@material-ui/icons/Home";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import PeopleIcon from "@material-ui/icons/People";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import ShareIcon from "@material-ui/icons/Share";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import StoreIcon from "@material-ui/icons/Store";
import ViewListIcon from "@material-ui/icons/ViewList";
import Skeleton from "@material-ui/lab/Skeleton";
import InboxIcon from "@material-ui/icons/Inbox";
import ArchiveIcon from "@material-ui/icons/Archive";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { API, graphqlOperation } from "aws-amplify";
import React, { useContext, useMemo, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { resizeImage } from "../components/FileUploader";
import ImageLoader from "../components/ImageLoader";
import logger from "../logger";
import { formatBytes } from "../functions";
import { updateStore } from "../graphql/mutations";
import { AppContext, signOut } from "../views/App";
import { MobileContext } from "../views/app/Mobile";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";

export const WIDTH = 320;

const useStyles = makeStyles(theme => ({
  drawer: {
    width: WIDTH,
    flexShrink: 0
  },
  drawerPaper: {
    width: WIDTH
  },
  drawerContainer: {
    overflow: "auto"
  },
  logoArea: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 1, 1, 0)
  },
  logo: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    backgroundColor: theme.palette.primary.contrastText
  },
  logoLoading: {
    width: theme.spacing(8),
    height: theme.spacing(8)
  },
  title: {
    color: theme.palette.primary.contrastText,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
  },
  listNested: {
    paddingLeft: theme.spacing(4)
  },
  dialog: {
    transform: "translateY(-100%)"
  }
}));

const SideBar = ({
  dense,
  open,
  onClose,
  onInicio,
  onPedidosRecibidos,
  onPedidosAbandonados,
  onPedidosArchivados,
  onCatalogo,
  onClientes,
  onTienda,
  onUsuario,
  onBilletera
}) => {
  const classes = useStyles();
  const { usuario, store, view, onViewChange, onStoreChange } = useContext(AppContext);
  const { mobile } = useContext(MobileContext);
  const [openPedidos, setOpenPedidos] = useState(true);
  const [showStoreLinkDialog, setShowStoreLinkDialog] = useState(false);
  const [copiado, setCopiado] = useState(false);
  const [loading, setLoading] = useState(false);

  const storeUrl = useMemo(() => {
    if (store.hostname) {
      return `https://${store.hostname}`;
    } else {
      const app = process.env.REACT_APP_ENV === "prod" ? "app" : "devapp";
      return `https://${app}.carritofacil.cl/${store.slug}`;
    }
  }, [store]);

  const onFileSelected = files => {
    setLoading(true);
    const file = Array.from(files)[0];

    const type = "image/jpeg";
    const extension = ".jpeg";
    const name = file.name.split(".")[0];

    resizeImage(file, blob => {
      const newFile = {
        name,
        extension,
        type,
        blob,
        url: URL.createObjectURL(blob),
        size: formatBytes(blob.size)
      };

      saveLogo(newFile);
    });
  };

  const saveLogo = async media => {
    try {
      media.name = "store_logo" + new Date().toISOString() + media.extension;
      media.storeId = store.id;
      media.key = media.storeId + "/" + media.name;

      const initUrl = {
        body: {
          key: media.key,
          type: media.type
        }
      };

      const urlData = await API.post(process.env.REACT_APP_HUB_API, "/uploader", initUrl);

      let url = undefined;
      let uploaded = false;

      if (urlData.success && urlData.url) {
        url = urlData.url;
      }

      if (url) {
        const initPut = {
          method: "PUT",
          headers: {
            "x-amz-acl": "public-read"
          },
          body: media.blob
        };
        const upladedData = await fetch(urlData.url, initPut);

        if (upladedData.ok) {
          uploaded = true;
        }
      }

      if (uploaded) {
        const s3media = {
          key: media.key,
          name: media.name,
          extension: media.extension,
          size: media.size,
          type: media.type,
          bucket: process.env.REACT_APP_CF_BUCKET
        };

        const vars = {
          input: {
            id: store.id,
            logo: s3media
          }
        };

        const result = await API.graphql(graphqlOperation(updateStore, vars));

        if (result.data.updateStore) {
          const body = JSON.parse(result.data.updateStore.body);

          onStoreChange({
            ...result.data.updateStore,
            body
          });
        }
      }
    } catch (err) {
      logger("SideBar.saveLogo.error", err);
    } finally {
      setLoading(false);
    }
  };

  const openMenuPedidos = () => {
    setOpenPedidos(!openPedidos);
  };

  const renderStoreLogo = () => {
    return (
      <>
        <input
          accept="image/*"
          style={{ display: "none" }}
          id="upload-store-logo"
          type="file"
          disabled={loading}
          onChange={({ target }) => onFileSelected(target.files)}
        />

        <label htmlFor="upload-store-logo" className="m-0">
          <IconButton disabled={loading} component="span">
            {store.logo && store.logo.key && !loading ? (
              <ImageLoader
                imgKey={store.logo.key}
                className={clsx(classes.logo, "logoUploader")}
                avatar
                variant="circle"
                alt="Logo Tienda"
                skeletonVariant="circle"
                skeletonClassName={classes.logoLoading}
              />
            ) : !loading ? (
              <Avatar
                className={classes.logo}
                alt="Logo Tienda"
                src={`${process.env.PUBLIC_URL}/assets/images/logo_cf.png`}
              />
            ) : (
              <Skeleton variant="circle" className={classes.logoLoading} />
            )}
          </IconButton>
        </label>
      </>
    );
  };

  const StoreLinkDialog = () => {
    return (
      store &&
      store.id && (
        <Dialog
          fullWidth
          maxWidth="sm"
          PaperProps={{ className: classes.dialog }}
          open={showStoreLinkDialog}
          onClose={() => setShowStoreLinkDialog(false)}
        >
          <DialogTitle>Link a tu Tienda</DialogTitle>

          <DialogContent>
            <DialogContentText>Copia este link y compártelo en redes sociales.</DialogContentText>

            <TextField
              readOnly
              fullWidth
              className="mb-4"
              value={storeUrl}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CopyToClipboard onCopy={() => setCopiado(true)} text={storeUrl}>
                      <IconButton>
                        <FileCopyIcon />
                      </IconButton>
                    </CopyToClipboard>
                  </InputAdornment>
                )
              }}
            />

            {copiado && (
              <Typography align="center" className="text-success mb-4">
                ¡Link copiado!
              </Typography>
            )}
          </DialogContent>
        </Dialog>
      )
    );
  };

  return (
    <>
      <StoreLinkDialog />

      <Drawer
        className={classes.drawer}
        variant={mobile ? "temporary" : "permanent"}
        open={open}
        onClose={onClose}
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <div className={classes.drawerContainer}>
          <div className={classes.logoArea}>
            {renderStoreLogo()}
            <Typography className={classes.title} variant="h6">
              {store.name}
            </Typography>
          </div>

          <List component="nav" dense={dense}>
            <ListItem
              button
              selected={view === "inicio"}
              onClick={() => {
                onViewChange("inicio");
                onInicio();
              }}
            >
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Inicio" />
            </ListItem>

            <ListItem button onClick={openMenuPedidos}>
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Pedidos" />
              {openPedidos ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openPedidos} timeout="auto" unmountOnExit>
              <List component="div" disablePadding dense={dense}>
                <ListItem
                  button
                  selected={view === "pedidos_recibidos"}
                  className={classes.listNested}
                  onClick={() => {
                    onViewChange("pedidos_recibidos");
                    onPedidosRecibidos();
                  }}
                >
                  <ListItemIcon>
                    <InboxIcon />
                  </ListItemIcon>
                  <ListItemText primary="Recibidos" />
                </ListItem>

                <ListItem
                  button
                  selected={view === "pedidos_abandonados"}
                  className={classes.listNested}
                  onClick={() => {
                    onViewChange("pedidos_abandonados");
                    onPedidosAbandonados();
                  }}
                >
                  <ListItemIcon>
                    <AccessTimeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Abandonados" />
                </ListItem>

                <ListItem
                  button
                  selected={view === "pedidos_archivados"}
                  className={classes.listNested}
                  onClick={() => {
                    onViewChange("pedidos_archivados");
                    onPedidosArchivados();
                  }}
                >
                  <ListItemIcon>
                    <ArchiveIcon />
                  </ListItemIcon>
                  <ListItemText primary="Archivados" />
                </ListItem>
              </List>
            </Collapse>

            <ListItem
              button
              selected={view === "catalogo"}
              onClick={() => {
                onViewChange("catalogo");
                onCatalogo();
              }}
            >
              <ListItemIcon>
                <ShoppingCartIcon />
              </ListItemIcon>
              <ListItemText primary="Catálogo" />
            </ListItem>

            <ListItem
              button
              selected={view === "clientes"}
              onClick={() => {
                onViewChange("clientes");
                onClientes();
              }}
            >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Clientes" />
            </ListItem>
          </List>

          <Divider />

          <List dense={dense}>
            <ListItem button onClick={() => setShowStoreLinkDialog(true)}>
              <ListItemIcon>
                <ShareIcon />
              </ListItemIcon>
              <ListItemText primary="Compartir" />
            </ListItem>

            <ListItem button component="a" href={storeUrl} target="_blank">
              <ListItemIcon>
                <OpenInNewIcon />
              </ListItemIcon>
              <ListItemText primary="Ir a tu Tienda" />
            </ListItem>
          </List>

          <Divider />

          <List dense={dense}>
            <ListItem
              button
              selected={view === "billetera"}
              onClick={() => {
                onViewChange("billetera");
                onBilletera();
              }}
            >
              <ListItemIcon>
                <AccountBalanceWalletIcon />
              </ListItemIcon>
              <ListItemText primary="Billetera" />
            </ListItem>

            <ListItem
              button
              selected={view === "perfil_tienda"}
              onClick={() => {
                onViewChange("perfil_tienda");
                onTienda();
              }}
            >
              <ListItemIcon>
                <StoreIcon />
              </ListItemIcon>
              <ListItemText primary="Perfil de Tienda" />
            </ListItem>

            <ListItem
              button
              selected={view === "perfil_usuario"}
              onClick={() => {
                onViewChange("perfil_usuario");
                onUsuario();
              }}
            >
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText
                primary={`${usuario.primer_nombre_usuario} ${usuario.apellido_paterno_usuario}`}
              />
            </ListItem>

            <ListItem button onClick={signOut}>
              <ListItemIcon>
                <PowerSettingsNewIcon />
              </ListItemIcon>
              <ListItemText primary="Desconectar" />
            </ListItem>
          </List>
        </div>
      </Drawer>
    </>
  );
};

export default SideBar;
